import {
  SEARCH_QUERY,
  SEARCH_RESET,
  SEARCH_LOAD_COMPLETE,
  SEARCH_CATEGORY,
  SEARCH_CATEGORY_COMPLETE,
  SEARCH_CHANGE_PAGE,
  SET_QUERY_STRING
} from '../constants/actionTypes';

import { getSearchByType } from '../utils/apiSearch';

const getTotals = (category, data) => {
  switch (category) {
    case 'users':
      return data.totalUsers;
    case 'contents':
      return data.totalContents;
    case 'documents':
      return data.totalDocuments;
    case 'folders':
      return data.totalFolders;
    case 'associations':
      return data.totalAssociations;
    default:
      return data.totalAll;
  }
};

export const enterSearch = query => (dispatch, getState) => {
  const stateSearch = getState().search;

  dispatch({ type: SEARCH_QUERY, query });

  getSearchByType(stateSearch.category, {
    search: query,
    page: stateSearch.page,
    size: stateSearch.size
  }).then(response => {
    dispatch({
      type: SEARCH_LOAD_COMPLETE,
      ...response,
      total: getTotals(stateSearch.category, response)
    });
  });
};

export const resetSearch = () => dispatch => {
  dispatch({ type: SEARCH_RESET });
  dispatch({ type: SET_QUERY_STRING, searchQuery: '' });
};

export const searchByType = category => (dispatch, getState) => {
  const stateSearch = getState().search;

  dispatch({ type: SEARCH_CATEGORY, category });

  getSearchByType(category, {
    search: stateSearch.query,
    page: 1,
    size: stateSearch.size
  }).then(response => {
    dispatch({
      type: SEARCH_CATEGORY_COMPLETE,
      ...response,
      total: getTotals(category, response)
    });
  });
};

export const searchChangePage = page => (dispatch, getState) => {
  dispatch({ type: SEARCH_CHANGE_PAGE, page });

  const stateSearch = getState().search;

  getSearchByType(stateSearch.category, {
    search: stateSearch.query,
    page,
    size: stateSearch.size
  }).then(response => {
    dispatch({
      type: SEARCH_LOAD_COMPLETE,
      ...response,
      total: getTotals(stateSearch.category, response)
    });
  });
};
